import { down } from 'slide-element';

document.addEventListener('DOMContentLoaded', () => {
    const $body = document.querySelector('body');
    const $searchButton = document.querySelectorAll('.btn-search-panel');
    const $searchPanel = document.querySelector('.search-wrapper-panel');
    const $mobileContainer = document.querySelector('.nav-mobile-search');
    const $desktopContainer = document.querySelector('.nav-search');
    const $mobileSearchInput = document.querySelector('.nav-mobile-search-input');
    const $searchInput = document.querySelector('.search-field');

    const moveSearchPanel = () => {
        const isTouchDevice = window.matchMedia('(hover: none)').matches;
        const isMobileView = window.innerWidth < 1140 || isTouchDevice;

        // Move panel to mobile container
        if (isMobileView) {
            if ($searchPanel.parentNode !== $mobileContainer) {
                $mobileContainer.appendChild($searchPanel);
            }
            return;
        }

        // Move back panel to desktop container
        if ($searchPanel.parentNode !== $desktopContainer) {
            $desktopContainer.appendChild($searchPanel);
        }
    };

    // on load
    moveSearchPanel();

    // On resize
    window.addEventListener('resize', moveSearchPanel);

    $searchButton.forEach((button) => {
        button.addEventListener('click', () => {
            setTimeout(() => {
                button.classList.add('is-active');
                $body.classList.add('search-panel-open');
                $searchPanel.classList.add('open');
                $searchPanel.style.display = 'block';
                $searchInput.focus();
            }, 100);
            down($searchPanel);
        });
    });

    $mobileSearchInput.addEventListener('focus', () => {
        $searchPanel.classList.add('open');
        $searchPanel.style.display = 'block';
        setTimeout(() => {
            $searchPanel.classList.add('open');
            $searchInput.focus();
        }, 100);
    });

    const closeSearchPanel = () => {
        $searchButton.forEach((button) => {
            button.classList.remove('is-active');
        });
        $body.classList.remove('search-panel-open');
        $searchPanel.classList.remove('open');
        $searchPanel.style.display = 'none';
    };

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && $searchPanel.classList.contains('open')) {
            closeSearchPanel();
        }
    });

    $searchPanel.addEventListener('focusout', (event) => {
        if (!$searchPanel.contains(event.relatedTarget) && event.target !== $searchInput && $searchPanel.classList.contains('open')) {
            closeSearchPanel();
        }
    });
});
